import React, { useState, useContext, useCallback, useMemo } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import Search from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import { useSuccessStore } from "./../../helpers/state";
import { useOneUser } from "./../../helpers/APIServices";
import Swal from "sweetalert2";
import { ScrollContext, UserContext } from "../../Layout";
import { useNavigate } from "react-router-dom";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import Autocomplete from "@mui/material/Autocomplete";
import PartCard2 from "./PartCard2";

function Answer2() {
  const successState = useSuccessStore();
  const [success, setSuccess] = useState(true);
  const [search, setSearch] = useState("");
  const user = JSON.parse(localStorage.getItem("QCAPPuser"));
  const { data, error, isLoading, mutate } = useOneUser(user.id);
  const userUseContext = useContext(UserContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const refLayout = useContext(ScrollContext);
  const [uniqueCustomers, setUniqueCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("All");

  const handleSearch = (value) => {
    setSearch(value);
  };
  const handleUpdateCustomers = useCallback((customers) => {
    setUniqueCustomers(customers);
  }, []);
  const handleSelectCustomer = (event, value) => {
    setSelectedCustomer(value || "All");
  };

  if (userUseContext) {
    if (!userUseContext.signature) {
      Swal.fire({
        title: "ผู้ใช้งานนี้ไม่มีข้อมูลลายเซ็น",
        text: "กรุณาเพิ่มลายเซ็น",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "เพิ่มลายเซ็น",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate(`/layout/profile/${userUseContext.id}`);
        }
      });
    }
  }

  if (error) return <div>failed to load</div>;

  return (
    <div className={``}>
      <div
        className={`bg-colorSub fixed bottom-0 right-0 mx-8 my-4 p-4 rounded-full flex text-white cursor-pointer hover:bg-blue-500`}
        onClick={() => {
          refLayout.current.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        <ArrowUpwardIcon />
      </div>
      {/* <SimpleBackdrop open={paper.isLoading} setOpen={setLoading}/> */}
      <div className="mb-2 flex">
        <TextField
          onChange={(e) => {
            handleSearch(e.target.value);
          }}
          placeholder="Search by Part Name or Part Code"
          className="flex-1"
          variant="outlined"
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        ></TextField>
        {uniqueCustomers && (
          <Autocomplete
            disablePortal
            size="small"
            options={["All", ...uniqueCustomers]}
            value={selectedCustomer}
            onChange={handleSelectCustomer}
            sx={{ marginLeft: 2, width: 250 }}
            renderInput={(params) => <TextField {...params} label="Customer" />}
          />
        )}
      </div>
      <PartCard2
        user={data.data}
        setSuccess={setSuccess}
        search={search}
        onUpdateCustomers={handleUpdateCustomers}
        selectedCustomer={selectedCustomer}
      />
    </div>
  );
}

export default Answer2;

// export function useComponentRefs(length) {
// return Array.from({ length }, () => React.useRef(null));
// }
